﻿<div>
    <!-- <hr class="border-top-color" /> -->
    <div><a target="_blank" href="{{privacyStatementPath}}">Privacy</a></div>
    <div> <a target="_blank" href="http://www.deloitte.com/about">About</a> </div>
    <div> &copy; {{year}}</div>
</div>